import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import SvgIcon from "../../../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { toast } from "react-toastify";
import axios from "axios";
import {
  getAPIURL,
  getAPIURLAWS,
  getUserID,
} from "../../../../../../services/helper";
import Swal from "sweetalert2";
import { deleteGroup } from "../../../../../../ReduxToolkit/Reducers/ChatReducer";
import { useDispatch } from "react-redux";

export default function GroupEdit({ className, id }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const api_url = getAPIURL();
  const api_url_aws = getAPIURLAWS();
  const Dispatch = useDispatch();
  const handleClearChat = async () => {
    try {
      const resp = await axios.delete(`${api_url}/clear-chat/${id}`);
      console.log(resp);
    } catch (error) {
      toast.error(error);
      console.log(error);
    }
  };
  const handleDeleteChat = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This Group Will Be Deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    });

    if (result.isConfirmed) {
      const data = {
        groupId: String(id),
        user_id: Number(getUserID()),
      };
      try {
        const resp = await axios.delete(`${api_url_aws}/chats/groups`, {
          data: data,
        });
        if (resp.data.success) {
          toast.success("Group Deleted");
          Dispatch(deleteGroup(id));
        } else {
          toast.error("Error Deleting Group ");
        }
      } catch (error) {
        toast.error(error);
        console.log(error);
      }
    }
  };
  return (
    <div className={`contact-edit ${className}`}>
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        onClick={(e) => e.stopPropagation}
      >
        <DropdownToggle color="transparent d-flex align-items-center">
          <SvgIcon iconId="menubar" />
        </DropdownToggle>
        <DropdownMenu end={true}>
          <DropdownItem onClick={handleClearChat}>{"Clear Chat"}</DropdownItem>
          <DropdownItem onClick={handleDeleteChat}>
            {"Delete Group"}
          </DropdownItem>
          {/* <DropdownItem>{"Add to favorites"}</DropdownItem> */}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
